module.exports = __webpack_public_path__ + "img/paypalfeed.ff66ae8e.png";